import PropTypes from 'prop-types';
import DeliveryOptionPricePropType from '../../../propTypes/DeliveryOptionPrice.proptype';

export default {
  date: PropTypes.string.isRequired,
  price: DeliveryOptionPricePropType.isRequired,
  discountedPrice: DeliveryOptionPricePropType.isRequired,
  taxPrice: DeliveryOptionPricePropType.isRequired,
  available: PropTypes.bool.isRequired,
};
